export function sendMessageToHost(message) {
    var parentWindow = window.parent;
    parentWindow.postMessage(message, '*');
}
